<template>
  <div class="block-click" @click.stop="doNothing">
    <v-popover
      class="ks-dropdown"
      popoverClass="ks-dropdown-theme"
      :disabled="isDisabled"
      :open.sync="open"
      placement="left-start"
      :container="container"
    >
      <div class="popover-target">
        <slot />
      </div>

      <template slot="popover">
        <div
          class="option"
          v-close-popover
          v-for="(option, index) in options"
          :key="index"
          @click="option.handler"
        >{{ option.label }}</div>
      </template>
    </v-popover>
  </div>
</template>

<script>
  export default {
    name: 'ks-dropdown',
    data () {
      return {
        open: false,
      }
    },
    computed: {
      isDisabled () {
        return this.disabled
      },
    },
    methods: {
      doNothing () {
        return null
      },
      $hide () {
        this.open = false
      },
      $show () {
        this.open = true
      },
      $toggle () {
        this.open = !this.open
      },
    },
    props: {
      /**
       * [{
       *   label: 'Same Label',
       *   handler: () => { ... }
       * }]
       */
      container: {
        type: String,
        default: 'body',
      },
      options: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="scss">
  .tooltip.ks-dropdown-theme .tooltip-inner {
    background-color: white;
    color: #555;
    border-radius: 1px;
    min-width: 150px;
    font-size: 1rem;
    padding: 0;

    .option {
      text-align: left;
      padding: 8px;
      &:hover {
        cursor: pointer;
        background-color: #c7c7c7;
      }
    }
  }

  .ks-dropdown {
    .popover-target {
      &:hover {
        cursor: pointer;
      }
    }

    &.block-click {
      pointer-events: none;
    }
  }
</style>
